module.exports = __webpack_public_path__ + "static/media/stef.40f30fe7.png";